module.exports = __webpack_public_path__ + "img/bus-partner-img2.dc5c632d.png";